import { replaceTextReferences } from './text-references';

const PULL_REQUEST_REFERENCE_PATTERN =
  /(^|[^\p{L}\p{N}_/-]|(?<![\p{L}\p{N}_-])-)(?:([a-z\d](?:[a-z\d-]{0,37}[a-z\d])?)\/([\w.-]+))?#([1-9]\d*)(?![\p{L}\p{N}_])/giu;

export type PullRequestReferenceOptions = {
  org: string;
  repo: string;
};

export type PullRequestReferenceMatch = {
  end: number;
  number: string;
  options: PullRequestReferenceOptions;
  reference: string;
  start: number;
};

export function buildPullRequestUrl(
  { org, repo }: PullRequestReferenceOptions,
  number: string,
): string {
  return `https://cubic.dev/pr/${encodeURIComponent(org)}/${encodeURIComponent(repo)}/pull/${number}`;
}

export function findPullRequestReferences(
  content: string,
  options: PullRequestReferenceOptions,
): PullRequestReferenceMatch[] {
  const references: PullRequestReferenceMatch[] = [];

  for (const match of content.matchAll(PULL_REQUEST_REFERENCE_PATTERN)) {
    const prefix = match[1] ?? '';
    const referencedOrg = match[2];
    const referencedRepo = match[3];
    const number = match[4];
    if (!number) {
      continue;
    }

    const start = (match.index ?? 0) + prefix.length;
    const referenceOptions =
      referencedOrg && referencedRepo ? { org: referencedOrg, repo: referencedRepo } : options;
    const reference =
      referencedOrg && referencedRepo
        ? `${referencedOrg}/${referencedRepo}#${number}`
        : `#${number}`;
    references.push({
      end: start + reference.length,
      number,
      options: referenceOptions,
      reference,
      start,
    });
  }

  return references;
}

export function replacePullRequestReferences<T>(
  content: string,
  options: PullRequestReferenceOptions,
  createTextNode: (value: string) => T,
  createLinkNode: (match: PullRequestReferenceMatch) => T,
): T[] | null {
  return replaceTextReferences(
    content,
    findPullRequestReferences(content, options),
    createTextNode,
    createLinkNode,
  );
}
